import { get, has, flatten, compact, camelCase, sortBy } from 'lodash-es'
import { getRelationshipByType } from '@/js/helper/relationships-helper.js'
import { getLinkUrlOfType } from '@/js/helper/links-helper.js'
import { filter } from '@/js/helper/settings-filter.js'

import API_CONSTANTS from '@/js/helper/api-constants.js'

// const buildSubCatalog = (data, path = []) => {
//   return getCatalogItems(data).map(item => {
//     const childrenIds = item.catalog && item.catalog.length ? item.catalog.map(i => i.id) : []
//     const hasChildren = !!childrenIds.length
//     const myPath = [...path, item.id]
//     const catalog = hasChildren ? buildSubCatalog(item.catalog, myPath) : []
//     // const title = this.getTitleTranslated(item.title)
//     // const brand = this.getBrandList(item.title)

//     // this.addCategoryInfo({ id: item.id, title, path })
//     return {
//       ...item,
//       // title,
//       // brand,
//       catalog,
//       hasChildren,
//       childrenIds: [...childrenIds, ...flatten(catalog.map(c => c.childrenIds))],
//       path: myPath,
//     }
//   })
// }

export const getCatalogTitle = item => get(item, [API_CONSTANTS.ATTRIBUTES, API_CONSTANTS.TITLE])

export const getCatalogRelationships = relationships =>
  getRelationshipByType({
    relationships: relationships,
    type: API_CONSTANTS.CATALOG.TYPE,
  })

export const getCatalogItems = data =>
  data.map(item => ({
    title: getCatalogTitle(item),
    id: get(item, API_CONSTANTS.ID),
    links: get(item, API_CONSTANTS.LINKS, {}),
    attributes: get(item, API_CONSTANTS.ATTRIBUTES, {}),
    productsUrl: getLinkUrlOfType(get(item, API_CONSTANTS.LINKS), API_CONSTANTS.LINK.PRODUCT),
    catalog: getCatalogRelationships(get(item, API_CONSTANTS.RELATIONSHIPS)),
  }))

// export const buildCatalogTree = catalog => {
//   return Object.entries(catalog).reduce((result, [key, catalog]) => {
//     const catalogElements = getRelationshipByType({
//       relationships: get(catalog, API_CONSTANTS.RELATIONSHIPS, {}),
//       type: API_CONSTANTS.CATALOG.TYPE,
//     })
//     result[key] = buildSubCatalog(catalogElements)
//     return result
//   }, {})
// }

// const getCatalogChildrenInfo = catalogList => {
//   return catalogList.reduce((result, catalog) => {
//     return {
//       ...result,
//       [catalog.id]: { id: catalog.id, path: catalog.path, title: catalog.title },
//       ...(catalog.hasChildren ? getCatalogChildrenInfo(catalog.catalog) : {}),
//     }
//   }, {})
// }

// export const buildCatalogList = catalogTree => {
//   return Object.values(catalogTree).reduce((result, catalogList) => {
//     return { ...result, ...getCatalogChildrenInfo(catalogList) }
//   }, {})
// }

export const enrichCatalogTree = catalogTree => {
  return buildSubCatalog(Object.values(catalogTree))
}
const buildSubCatalog = data => {
  return sortBy(
    data.map(item => {
      const catalog = sortBy(
        item?.catalog ? buildSubCatalog(Object.values(item.catalog)) : [],
        'title',
      )
      const hasChildren = !!catalog.length
      const count = has(item, 'count')
        ? item.count
        : hasChildren
        ? catalog.reduce((acc, subCat) => subCat.count + acc, 0)
        : 0
      const childrenIds = hasChildren ? compact(catalog.map(i => i.id)) : []
      const subChildrenIds = hasChildren ? compact(flatten(catalog.map(i => i.childrenIds))) : []
      const brand = item.title
        ? filter?.config?.categoryTitleBrandMap?.[camelCase(item.title)]
        : undefined

      const result = {
        ...item,
        id: item.id ? item.id : `code${item.catalogCode}`,
        catalog,
        count,
        hasChildren,
        childrenIds: [...childrenIds, ...subChildrenIds],
        path: item?.id ? [item.id] : [],
      }

      if (brand) {
        result.brand = brand.split(',')
      }

      // console.log(result)
      return result
    }),
    'title',
  )
}
